import { withInstall } from '@antdv/utils';
import ACol from './src/Col';
import ARow from './src/Row';

export const Col = withInstall(ACol);
export const Row = withInstall(ARow);

export * from './src/interface';
export * from './src/props';
